import config from '@iotv/config';
import { AWSResources, DynamoDBMetrics, TimestreamMetrics } from '../../../../types/MetricWidgetTypes';
const debug = process.env.REACT_APP_DEBUG && false;
const { project, stage } = config;
export const getMetricsAry = ({ resource, metricName, selectedDimensionMapList }) => {
    let metrics = [];
    if (resource === 'Lambda' || resource === 'SQS') {
        const { dimensionName, dimensionValue } = selectedDimensionMapList[0];
        dimensionValue.forEach((value) => metrics.push([`AWS/${resource}`, `${metricName}`, `${dimensionName}`, `${project.code}-${stage}-${value}`]));
    }
    else if (resource == AWSResources.Timestream) {
        debug && console.log('Query TimeStream');
        const databaseDimension = selectedDimensionMapList.find((dimensionMap) => dimensionMap.dimensionName === 'DatabaseName');
        if (databaseDimension) {
            const { dimensionName: databaseDimensionName, dimensionValue: databaseNameList } = databaseDimension;
            const databaseMetricAry = [`AWS/${resource}`, `${metricName}`, `${databaseDimensionName}`, `${databaseNameList[0]}`];
            const operationDimension = selectedDimensionMapList.find((dimensionMap) => dimensionMap.dimensionName === 'Operation');
            if (metricName === TimestreamMetrics.SuccessfulRequestLatency) {
                const tableDimension = selectedDimensionMapList.find((dimensionMap) => dimensionMap.dimensionName === 'TableName');
                const { dimensionName: tableDimensionName, dimensionValue: tableNameList } = tableDimension;
                operationDimension &&
                    tableDimensionName &&
                    tableNameList &&
                    operationDimension.dimensionValue.forEach((operation) => {
                        tableNameList.forEach((tableName) => metrics.push([...databaseMetricAry, `${tableDimensionName}`, `${tableName}`, `${operationDimension.dimensionName}`, `${operation}`]));
                    });
            }
            else {
                operationDimension &&
                    operationDimension.dimensionValue.forEach((operation) => metrics.push([...databaseMetricAry, `${operationDimension.dimensionName}`, `${operation}`]));
            }
        }
    }
    else if (resource == AWSResources.DynamoDB) {
        debug && console.log('Query DynamoDB');
        const [tableDimension, ...additionalDimension] = selectedDimensionMapList;
        const { dimensionName: tableDimensionName, dimensionValue: tableNameList } = tableDimension;
        const tableBaseMetricAry = [`AWS/${resource}`, `${metricName}`, `${tableDimensionName}`, `${tableNameList[0]}`];
        metrics.push(tableBaseMetricAry);
        const additionalMetrics = [];
        if (additionalDimension.length > 0) {
            if (metricName === DynamoDBMetrics.ConsumedReadCapacityUnits || metricName === DynamoDBMetrics.ConsumedWriteCapacityUnits) {
                const indexDimension = selectedDimensionMapList.find((dimensionMap) => dimensionMap.dimensionName === 'GlobalSecondaryIndexName');
                indexDimension &&
                    indexDimension.dimensionValue.forEach((index) => additionalMetrics.push([...tableBaseMetricAry, `${indexDimension.dimensionName}`, `${index}`]));
            }
            else if (metricName === DynamoDBMetrics.SuccessfulRequestLatency) {
                const operationDimension = selectedDimensionMapList.find((dimensionMap) => dimensionMap.dimensionName === 'Operation');
                operationDimension &&
                    operationDimension.dimensionValue.forEach((operation) => additionalMetrics.push([...tableBaseMetricAry, `${operationDimension.dimensionName}`, `${operation}`]));
            }
        }
        metrics = additionalMetrics.length > 0 ? [...additionalMetrics] : metrics;
    }
    return metrics;
};
